import {EmblaOptionsType} from 'embla-carousel';
import EmblaCarousel from "./EmblaCarousel";
import '../../../../css/embla.css';
import { LargerHeading } from '../../../../lib/Font/styles';
import { Container } from './styles';

const OPTIONS: EmblaOptionsType = {loop: true}
const SLIDE_COUNT = 5
const SLIDES = Array.from(Array(SLIDE_COUNT).keys())
const ImpressionsContainer = () => {
    return (
        <Container>
            <LargerHeading>IMPRESSIONEN.</LargerHeading>
            <EmblaCarousel slides={SLIDES} options={OPTIONS} />
        </Container>
    );
}
 
export default ImpressionsContainer;